import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Hook personalizado para validar si el usuario tiene acceso a la ruta actual
 * basándose en los menús permitidos que devuelve el backend.
 *
 * @returns {Object} { isAuthorized: boolean, isChecking: boolean }
 */
const useRouteAuthorization = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isAuthorized, setIsAuthorized] = useState(true);
  const [isChecking, setIsChecking] = useState(true);

  useEffect(() => {
    const checkAuthorization = () => {
      setIsChecking(true);

      // Obtener datos del usuario desde sessionStorage
      const usuarioData = window.sessionStorage.getItem('usuario');

      if (!usuarioData) {
        // Si no hay usuario, redirigir a login
        navigate('/', { replace: true });
        return;
      }

      try {
        const userData = JSON.parse(usuarioData);
        const menus = userData?.result?.menus || [];
        const currentPath = location.pathname;

        // Rutas públicas o que no requieren validación específica
        const publicRoutes = ['/', '/login'];
        if (publicRoutes.includes(currentPath)) {
          setIsAuthorized(true);
          setIsChecking(false);
          return;
        }

        // Validar si la ruta actual está en la lista de menús permitidos
        const hasAccess = menus.some(menu => {
          const menuUrl = menu.url;

          // Coincidencia exacta
          if (currentPath === menuUrl) {
            return true;
          }

          // Validar subrutas: si el menu permite /auth/contratos,
          // también permitir /auth/contratos/detalle/123
          if (currentPath.startsWith(menuUrl + '/')) {
            return true;
          }

          return false;
        });

        if (!hasAccess) {
          setIsAuthorized(false);
          navigate('/auth/unauthorized', { replace: true });
        } else {
          setIsAuthorized(true);
        }

      } catch (error) {
        console.error('Error al validar autorización:', error);
        // En caso de error al parsear, redirigir a login por seguridad
        navigate('/', { replace: true });
      } finally {
        setIsChecking(false);
      }
    };

    checkAuthorization();
  }, [location.pathname, navigate]);

  return { isAuthorized, isChecking };
};

export default useRouteAuthorization;
